<template>
<div class="write-message-container">
    <div class="card-image-container">
        <img class="lazyload" width="280" height="280" loading="lazy" :src="selectedCard | getProductImage">
        <div>
            <div v-if="selectedCard.images.length > 1" class="card-secondary-images w-100 m-t-1rem">
                <img class="w-25 h-auto" width="20" height="20" :src="selectedCard.images[1].src">
            </div>
            <button class="blue-span color-link underline  flex flex-align-center flex-justify-between gap-05vw" @click="closeCard">
                <img width="15px" height="10px" class="h-auto" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit.svg?v=1749479131"/>
                Change Card
            </button>
        </div>
    </div>
    <div class="write-container" :class="isBlankMessage ? 'blank' : ''">
        <div>
            <p class="body-header-4 font-bold">Type in your message below.</p>
            <p v-if="selectedCard.id != 7148612419749" class="body-base color-lightpurple lh-default m-b-1rem">One of our team members will hand write your message <br/> and pack it in with your box.</p>
            <p v-if="remainingCharacters < 0" class="red-span">Your message has a limit of 200 characters. Keep it short and sweet!</p>
            <div v-if="selectedCard.id != 7148612419749" class="blank-card-container flex flex-align-center gap-05vw m-b-1rem">
                <input :checked="isBlankMessage" v-on:change="changeBlankMessage()" id="blankCard" type="checkbox">
                <label for="blankCard" class="body-base color-link body-base underline  flex flex-align-center gap-05vw">Leave the card blank</label>
            </div>
        </div>
        
        <div  class="form-container">
            <div v-if="!isBlankMessage" class="message-container w-100 m-b-1rem">
                <label for="message" :class="showCardAlert ? 'red' : ''">Your Message:</label>
                <textarea class="w-100" placeholder="Start typing here..." maxlength="200" v-model="message" v-on:change="changeMessage()" cols="30" rows="3" id="message"></textarea>
            </div>
            <div class="w-100 flex flex-align-center flex-justify-between">
                <div v-if="!isBlankMessage" class="from-container">
                    <label for="from" :class="showCardAlert ? 'red' : ''">From:</label>
                    <input v-on:change="changeFrom()" placeholder="Your Name" maxlength="200" v-model="from" id="from" type="text">
                    <p class="purple-span" :class="remainingCharacters == 0 ? 'red' : ''">Characters Remaining {{remainingCharacters}}</p>
                </div>
                <button @click="openCart()" class="hb-btn primary" :class="isLoading ? 'isLoading' :'' ">{{buttonText}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters} from 'vuex';

export default {
    components:{
    },
    props:{
        isLoading: Boolean,
        buttonDisabled: Boolean,
        buttonText: String,
        selectedCard: Object,
        isBlankMessage: Boolean,
        fromData: String,
        messageData: String
    },
    data(){
        return{
            from: '',
            message: '',
        }
    },
    computed: {
        ...mapGetters([
            'showCardAlert'
        ]),
        remainingCharacters(){
            var currentMessage = this.from + this.message;
            var currentRemainingCharacters = 200 - currentMessage.length;
            
            return currentRemainingCharacters;
        },
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768;
        },
        closeCard(){
            this.$emit("closecard");
        },
        changeBlankMessage(){
            this.$emit("changeblankmessage");
        },
        openCart(){
            if(this.buttonDisabled){
                this.$store.commit('setShowCardAlert', true );
                this.$emit("cardwarning");
                return
            }
            this.$emit("opencart");
        },
        changeMessage(){
            this.$emit("changemessage",this.message);
        },
        changeFrom(){
            this.$emit("changefrom",this.from);
        }
    },
    mounted(){
        this.from = this.fromData;
        this.message = this.messageData;
    }
}
</script>

<style scoped>

/* Write message component START */
.write-message-container{
    width: 70%;
    display: flex;
    flex-direction: row;
    margin: 2% 0%;
    padding: 2% 1%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    justify-content: space-between;
}

.card-image-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 30%;
}

.card-image-container > img{
    width: 100%;
    height: auto;
}

.write-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 65%;
    min-height: 100%;
}

.write-container.blank{
    gap: 15px;
}

.form-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.from-container,.message-container{
    display: flex;
    flex-direction: column;
    width: 100%;
}

.from-container label,.message-container label{
    font-weight: bold;
    color: #0F0C38;
    font-size: 1vw;
}

.from-container label.red,.message-container label.red{
    color: red;
}

.from-container input{
    width: 40%;
}

.purple-span{
    font-size: 1vw;
    color: gray;
}

.purple-span.red{
    color: red;
}

.blue-span{
    font-size: 1vw;
}

.card-title{
    font-size: 1.1vw;
    font-weight: bold;
    padding-top: 5%;
    width: 100%;
}

.from-container .purple-span{
    padding: 2% 0%;
}

.write-container textarea{
    width: 90%;
    min-height: 20vh;
}

.write-container textarea,.write-container input{
    background: #FFFFFF !important;
    border: 1px solid #E5E7EB !important;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08) !important;
    border-radius: 4px !important;
    color: #0F0C38;
    height: unset !important;
    font-size: 1.2vw;
    accent-color: black;
}

.write-container textarea:focus-visible,.write-container input:focus-visible{
    border: 1px solid #E5E7EB !important;;
    outline: none;
}

.main-image-container{
    border: 1px solid #F5EEFE;
    width: 100%;
    border-radius: 4px;
    position: relative;
    display: flex;
}

.main-image-container.selected{
    border: 1px solid #16A34A;
}

.green-check{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.main-image{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
}
/* Write message component END */
</style>